import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkothrud() {



    const cardData = {

keyword: "Cab Service in Kothrud",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Kothrud for daily commuters, families, business travelers, and weekend travelers. We provide quick local rides, airport transfers, railway station drops, and comfortable outstation cab services from Kothrud to all major destinations across Maharashtra and India. Our fleet includes Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, we ensure a safe and comfortable travel experience from Kothrud.",

topPlaces: [
    {
        title: "Lonavala",
        description:
            "Lonavala is one of the most popular weekend destinations from Kothrud, known for its green valleys, waterfalls, forts, and scenic mountain views. It is perfect for short trips with attractions like Bhushi Dam, Tiger Point, and Rajmachi Fort."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for its cool climate, strawberry farms, and viewpoints like Arthur’s Seat and Wilson Point. It is a top family vacation destination from Kothrud."
    },
    {
        title: "Goa",
        description:
            "Goa is a top long-distance travel destination from Kothrud famous for beaches, nightlife, water sports, and Portuguese heritage. Popular spots include Baga Beach, Calangute, and Anjuna."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba. Devotees from Kothrud frequently travel here for spiritual darshan at Sai Baba Samadhi Mandir."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a holy city known for Trimbakeshwar Jyotirlinga, Panchvati, and Godavari river ghats. It is also famous for vineyards and wine tourism."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is a Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest and wildlife sanctuary. It is a popular spiritual and trekking destination."
    },
    {
        title: "Mumbai",
        description:
            "Mumbai is the financial capital of India known for Gateway of India, Marine Drive, Siddhivinayak Temple, and Juhu Beach. It is a major business and tourism destination from Kothrud."
    },
    {
        title: "Lavasa",
        description:
            "Lavasa is a planned hill city near Pune known for lakeside views, colorful buildings, boating, and peaceful weekend relaxation."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal beach destination known for clean beaches, sea forts, and relaxing weekend trips, ideal for families and groups."
    },
    {
        title: "Pune Darshan",
        description:
            "Pune Darshan includes famous attractions like Shaniwar Wada, Aga Khan Palace, Dagadusheth Ganpati, and Sinhagad Fort, offering a complete city sightseeing experience."
    }
],



services: [
    {
        name: "Cab Service in Kothrud",
        description:
            "Rising Cab Service offers Cab Service in Kothrud for residents, families, corporate professionals, and students looking for safe, reliable, and comfortable transportation. We provide well-maintained AC vehicles, experienced drivers, and 24x7 availability for local travel, airport transfers, and outstation trips. Our service ensures punctual pickups, smooth rides, and affordable pricing across Kothrud and Pune city."
    },
    {
        name: "Taxi Service in Kothrud",
        description:
            "Our Taxi Service in Kothrud ensures quick, safe, and convenient transportation for daily commuters, office travelers, and tourists. Rising Cab Service offers clean cars, professional chauffeurs, and flexible booking options for local rides, airport transfers, and intercity travel with complete reliability and comfort."
    },
    {
        name: "Kothrud Cab Service",
        description:
            "Rising Cab Service provides Kothrud Cab Service with comfortable and affordable rides across Pune and Maharashtra. Whether it is a short city trip or a long-distance journey, our experienced drivers ensure safe travel, timely pickup, and smooth travel experience for all passengers."
    },
    {
        name: "Kothrud Taxi Service",
        description:
            "Book Kothrud Taxi Service with Rising Cab Service for reliable, safe, and comfortable transportation. We provide well-maintained vehicles and experienced drivers for daily commuting, shopping trips, airport transfers, and outstation journeys."
    },
    {
        name: "Best Cab Service in Kothrud",
        description:
            "Rising Cab Service offers Best Cab Service in Kothrud with premium-quality transportation, transparent pricing, and 24x7 support. We ensure safe, comfortable, and reliable rides suitable for families, corporate clients, students, and solo travelers."
    },
    {
        name: "Online Cab Booking Kothrud",
        description:
            "Our Online Cab Booking Kothrud system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for both local and outstation travel needs."
    },
    {
        name: "Cab Hire in Kothrud",
        description:
            "Rising Cab Service offers Cab Hire in Kothrud for hourly rentals, full-day trips, corporate travel, and personal transportation needs. We provide flexible packages with professional drivers and comfortable vehicles for a smooth and stress-free travel experience."
    },
    {
        name: "Taxi Booking Kothrud",
        description:
            "Book Taxi Booking Kothrud with Rising Cab Service for fast, reliable, and affordable transportation. We ensure timely service, clean vehicles, and experienced drivers for all types of travel requirements including local and outstation trips."
    },
    {
        name: "Outstation Cab Service Kothrud",
        description:
            "Rising Cab Service provides Outstation Cab Service Kothrud for long-distance travel to popular destinations like Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Kolhapur, Pandharpur, Bhimashankar, and Aurangabad. We offer comfortable rides, experienced drivers, and flexible one-way or round-trip options for safe intercity travel."
    },
    {
        name: "Kothrud to Mumbai Cab",
        description:
            "Rising Cab Service offers Kothrud to Mumbai Cab for safe and comfortable intercity travel with experienced drivers, smooth highway rides, and flexible booking options for business and leisure trips."
    },
    {
        name: "Kothrud to Shirdi Cab",
        description:
            "Book Kothrud to Shirdi Cab with Rising Cab Service for a peaceful pilgrimage journey to Sai Baba temple with clean vehicles and reliable service for families and devotees."
    },
    {
        name: "Kothrud to Nashik Cab",
        description:
            "Our Kothrud to Nashik Cab service ensures safe and comfortable travel for family trips, pilgrimages, and business journeys with professional drivers and smooth transportation."
    },
    {
        name: "Kothrud to Goa Cab",
        description:
            "Rising Cab Service provides Kothrud to Goa Cab for a relaxing beach vacation with safe driving, comfortable vehicles, and smooth long-distance travel experience."
    },
    {
        name: "Kothrud to Mahabaleshwar Cab",
        description:
            "Book Kothrud to Mahabaleshwar Cab for scenic hill station travel with experienced chauffeurs and comfortable rides suitable for families and couples."
    },
    {
        name: "Kothrud to Lonavala Cab",
        description:
            "Rising Cab Service offers Kothrud to Lonavala Cab for quick weekend getaways with safe, affordable, and comfortable transportation options."
    },
    {
        name: "Kothrud to Kolhapur Cab",
        description:
            "Our Kothrud to Kolhapur Cab service ensures smooth pilgrimage and family travel with reliable drivers and well-maintained vehicles."
    },
    {
        name: "Kothrud to Pandharpur Cab",
        description:
            "Rising Cab Service provides Kothrud to Pandharpur Cab for devotees visiting Lord Vitthal temple with comfortable and safe travel arrangements."
    },
    {
        name: "Kothrud to Bhimashankar Cab",
        description:
            "Book Kothrud to Bhimashankar Cab for a spiritual Jyotirlinga pilgrimage with safe driving and experienced chauffeurs."
    },
    {
        name: "Kothrud to Aurangabad Cab",
        description:
            "Rising Cab Service offers Kothrud to Aurangabad Cab for heritage and tourism travel with professional drivers and reliable intercity service."
    },
    {
        name: "Innova Crysta on Rent in Kothrud",
        description:
            "Book Innova Crysta on Rent in Kothrud with Rising Cab Service for premium comfort, spacious seating, and luxury travel experience ideal for family and group trips."
    },
    {
        name: "Ertiga Cab Service Kothrud",
        description:
            "Rising Cab Service offers Ertiga Cab Service Kothrud for affordable and comfortable family travel with clean vehicles and professional drivers."
    },
    {
        name: "Swift Dzire Cab Service Kothrud",
        description:
            "Our Swift Dzire Cab Service Kothrud provides economical and comfortable rides ideal for daily commuting, city travel, and short-distance trips."
    },
    {
        name: "Sedan Cab Service Kothrud",
        description:
            "Rising Cab Service offers Sedan Cab Service Kothrud for budget-friendly and comfortable travel with well-maintained cars and experienced drivers."
    },
    {
        name: "SUV Cab Service Kothrud",
        description:
            "Book SUV Cab Service Kothrud for spacious and comfortable travel suitable for families, groups, and long-distance journeys with safe driving and reliable service."
    },
    {
        name: "Luxury Car Rental Kothrud",
        description:
            "Rising Cab Service provides Luxury Car Rental Kothrud for premium travel experiences with high-end vehicles, professional chauffeurs, and elegant comfort for special occasions and corporate travel."
    },
    {
        name: "Innova Cab Service Kothrud",
        description:
            "Our Innova Cab Service Kothrud ensures comfortable group travel with spacious seating, smooth rides, and reliable intercity transportation."
    },
    {
        name: "Kia Carens Cab Service Kothrud",
        description:
            "Rising Cab Service offers Kia Carens Cab Service Kothrud for modern, comfortable, and safe family travel with professional drivers and clean vehicles."
    },
    {
        name: "Premium Taxi Service Kothrud",
        description:
            "Book Premium Taxi Service Kothrud with Rising Cab Service for high-quality vehicles, professional drivers, and a superior travel experience for all occasions."
    },
    {
        name: "Cab Service in Kothrud Pune",
        description:
            "Rising Cab Service provides Cab Service in Kothrud Pune for reliable local and intercity transportation with 24x7 availability and affordable pricing."
    },
    {
        name: "Kothrud to Pune Airport Cab",
        description:
            "Our Kothrud to Pune Airport Cab ensures timely pickups, comfortable AC vehicles, and stress-free airport transfers with professional drivers."
    },
    {
        name: "Pune Airport to Kothrud Cab",
        description:
            "Rising Cab Service offers Pune Airport to Kothrud Cab for quick and reliable pickup service with safe and comfortable travel experience."
    },
    {
        name: "Corporate Cab Service in Kothrud",
        description:
            "Book Corporate Cab Service in Kothrud with Rising Cab Service for employee transportation, business travel, and office commuting solutions with punctual and professional service."
    },
    {
        name: "Online Cab Booking Kothrud",
        description:
            "Our Online Cab Booking Kothrud system ensures fast booking, instant confirmation, and transparent pricing for all local and outstation travel needs."
    }
],

tableData: [
    ["Cab Service in Kothrud", "Taxi Service in Kothrud"],
    ["Kothrud Cab Service", "Kothrud Taxi Service"],
    ["Best Cab Service in Kothrud", "Online Cab Booking Kothrud"],
    ["Cab Hire in Kothrud", "Taxi Booking Kothrud"],
    ["Outstation Cab Service Kothrud", "Kothrud to Mumbai Cab"],
    ["Kothrud to Shirdi Cab", "Kothrud to Nashik Cab"],
    ["Kothrud to Goa Cab", "Kothrud to Mahabaleshwar Cab"],
    ["Kothrud to Lonavala Cab", "Kothrud to Kolhapur Cab"],
    ["Kothrud to Pandharpur Cab", "Kothrud to Bhimashankar Cab"],
    ["Kothrud to Aurangabad Cab", "Innova Crysta on Rent in Kothrud"],
    ["Ertiga Cab Service Kothrud", "Swift Dzire Cab Service Kothrud"],
    ["Sedan Cab Service Kothrud", "SUV Cab Service Kothrud"],
    ["Luxury Car Rental Kothrud", "Innova Cab Service Kothrud"],
    ["Kia Carens Cab Service Kothrud", "Premium Taxi Service Kothrud"],
    ["Cab Service in Kothrud Pune", "Kothrud to Pune Airport Cab"],
    ["Pune Airport to Kothrud Cab", "Corporate Cab Service in Kothrud"],
    ["Online Cab Booking Kothrud"]
],





whychoose: [
    {
        WhyChooseheading: "Reliable Transportation Services in Kothrud",
        WhyChoosedescription: "Rising Cab Service provides dependable cab solutions for local travel, airport transfers, business trips, sightseeing tours, and outstation journeys from Kothrud."
    },
    {
        WhyChooseheading: "Easy Connectivity to Major Pune Locations",
        WhyChoosedescription: "Travel conveniently from Kothrud to Hinjewadi, Baner, Wakad, Shivajinagar, Pune Airport, Swargate, and other important destinations across the city."
    },
    {
        WhyChooseheading: "Ideal for Daily and Occasional Travel",
        WhyChoosedescription: "Whether it's a routine office commute, family outing, shopping trip, medical visit, or weekend getaway, our service caters to all travel requirements."
    },
    {
        WhyChooseheading: "Wide Selection of Comfortable Vehicles",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles depending on group size and travel preferences."
    },
    {
        WhyChooseheading: "Timely Pickup and Drop Assistance",
        WhyChoosedescription: "Our drivers ensure punctual arrivals and departures, helping passengers reach their destinations without unnecessary delays."
    },
    {
        WhyChooseheading: "Flexible Travel Plans for Every Customer",
        WhyChoosedescription: "One-way rides, round trips, hourly rentals, full-day bookings, and customized travel plans are available to suit different needs."
    },
    {
        WhyChooseheading: "Clean Vehicles with Professional Service",
        WhyChoosedescription: "Every vehicle is maintained to high standards and operated by courteous drivers focused on passenger comfort and safety."
    },
    {
        WhyChooseheading: "Popular Choice for Families and Professionals",
        WhyChoosedescription: "Rising Cab Service is trusted by families, working professionals, students, senior citizens, and tourists for comfortable transportation."
    }
]
};

const faqData = [
    {
        question: "What makes Kothrud an important location for cab services?",
        answer: "Kothrud is one of Pune's busiest residential and commercial areas with excellent connectivity to major business districts and tourist attractions."
    },
    {
        question: "Can travelers arrange airport transportation from Kothrud?",
        answer: "Yes, convenient pickup and drop services are available between Kothrud and Pune Airport."
    },
    {
        question: "Which nearby destinations are frequently visited from Kothrud?",
        answer: "Popular routes include Hinjewadi, Baner, Wakad, Shivajinagar, Pune Railway Station, Lonavala, Mahabaleshwar, and Mumbai."
    },
    {
        question: "Are vehicles available for family vacations and group tours?",
        answer: "Yes, spacious vehicles and Tempo Travellers can be arranged for family trips, sightseeing tours, and group travel."
    },
    {
        question: "Can business professionals use the service for meetings and events?",
        answer: "Yes, many executives and corporate employees utilize our transportation services for professional travel requirements."
    },
    {
        question: "Is full-day cab booking available in Kothrud?",
        answer: "Yes, customers can reserve vehicles for full-day usage, local travel, city tours, and personal requirements."
    },
    {
        question: "What vehicle categories are available for booking?",
        answer: "Available options include Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
    },
    {
        question: "Do you provide transportation for outstation destinations?",
        answer: "Yes, outstation cab services are available from Kothrud to destinations throughout Maharashtra and neighboring states."
    },
    {
        question: "Can travelers choose between one-way and return trips?",
        answer: "Yes, both one-way and round-trip travel options can be arranged according to customer preferences."
    },
    {
        question: "How can a customer reserve a cab in Kothrud?",
        answer: "Bookings can be confirmed through a phone call, WhatsApp message, or online inquiry with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sameer Patwardhan",
        feedback:
            "Finding dependable transportation in Kothrud became much easier after choosing Rising Cab Service. The punctuality, vehicle quality, and overall service have always been excellent.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Poonam Kulkarni",
        feedback:
            "During a recent family outing, everything was managed perfectly from pickup to drop-off. The comfortable ride and professional approach made the journey truly enjoyable.",
        rating: 5
    }
];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Kothrud",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-kothrud.jpg",
"description": "Book Cab Service in Kothrud with Rising Cab Service for local travel, airport transfers, corporate rides, and outstation trips. Enjoy safe, affordable, and reliable taxi service in Kothrud with AC cars, SUVs, luxury vehicles, and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-kothrud"
}
};







    return (
        <div>


<Helmet>
  <title>Cab Service in Kothrud | Local & Outstation Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Kothrud for local travel, airport transfers, corporate rides, and outstation trips. Affordable taxi service with Innova Crysta, Ertiga, Sedan, SUV, and luxury cars with professional drivers."
/>

<meta
 name="keywords"
 content="Cab Service in Kothrud, Taxi Service in Kothrud, Kothrud Cab Service, Kothrud Taxi Service, Best Cab Service in Kothrud, Online Cab Booking Kothrud, Cab Hire in Kothrud, Taxi Booking Kothrud, Outstation Cab Service Kothrud, Kothrud to Mumbai Cab, Kothrud to Shirdi Cab, Kothrud to Nashik Cab, Kothrud to Goa Cab, Kothrud to Mahabaleshwar Cab, Kothrud to Lonavala Cab, Kothrud to Kolhapur Cab, Kothrud to Pandharpur Cab, Kothrud to Bhimashankar Cab, Kothrud to Aurangabad Cab, Innova Crysta on Rent in Kothrud, Ertiga Cab Service Kothrud, Swift Dzire Cab Service Kothrud, Sedan Cab Service Kothrud, SUV Cab Service Kothrud, Luxury Car Rental Kothrud, Innova Cab Service Kothrud, Kia Carens Cab Service Kothrud, Premium Taxi Service Kothrud"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinkothrud;